export default "__VITE_ASSET__e7c4a9a5__"